(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["text"] && !Shopify.designMode) return;
  try {
    (function () {
    function getVideoId(url) {
      var match = url.match(/\/embed\/([^?&/]+)/);
      return match ? match[1] : '';
    }

    function initYouTubePosters(root) {
      var scope = root && root.querySelectorAll ? root : document;
      scope.querySelectorAll('iframe[data-youtube-src]').forEach(function (iframe) {
        if (iframe.dataset.youtubePosterReady === '1') return;
        iframe.dataset.youtubePosterReady = '1';

        var src = iframe.dataset.youtubeSrc;
        var videoId = getVideoId(src);
        if (!videoId) return;

        var poster = document.createElement('button');
        var playLabel = iframe.closest('.text-block-media')?.dataset.videoPlayLabel || 'Play video';
        poster.type = 'button';
        poster.className = 'text-block-media__video-poster';
        poster.setAttribute('aria-label', playLabel + (iframe.title ? ': ' + iframe.title : ''));
        poster.style.backgroundImage = 'url("https://i.ytimg.com/vi/' + encodeURIComponent(videoId) + '/hqdefault.jpg")';

        poster.addEventListener('click', function () {
          var player = iframe.cloneNode(false);
          var separator = src.indexOf('?') === -1 ? '?' : '&';
          player.removeAttribute('data-youtube-src');
          player.removeAttribute('data-youtube-poster-ready');
          player.src = src + separator + 'autoplay=1';
          player.loading = 'lazy';
          player.allow = iframe.allow || 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
          player.allowFullscreen = true;
          poster.replaceWith(player);
          player.focus();
        });

        iframe.replaceWith(poster);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initYouTubePosters(document);
      });
    } else {
      initYouTubePosters(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initYouTubePosters(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
